<template>
  <div class="pd-10"
    :class="{ 'col-xs-12 col-sm-6 col-md-4': widgetTrackplusFlag, 'exp-pd-tp-0': panel && panel.card_number != '2' && panel.card_number != '3' }">
    <div class="expiry_pending" :class="widgetTrackplusFlag ? 'widget' : ''">
      <div class="col-xs-12 title d-flex">
        <!-- <img src="/static/images/icons/compliance_service.svg" class="track_plus_icon_blue" /> -->
        <span class="compliance_title">{{ $t('complianceImpacts') }}</span>
      </div>
      <div class="compliance_details">{{ $t('complianceImpactsMessage') }}</div>
      <div class="mt-15">
        <div v-for="(item, key, index) in expiration_details" :key="index">
          <div class="card_details" v-if="key !== 'expired'">
            <div class="rounded_corner">
              <span v-if="key !== 'expired'" class="" id="item_number">
                {{ item.number }}
              </span>
            </div>
            <span v-if="key === 'month'" class=" cursor_pointer" @click="goToCompliance('month')">
              <h4 style="color: #C02032;" class="mb-0 impact_type">{{ $t('highImpact') }}</h4>
              <div class="expire_time">{{ $t('certificateExpiringWithin3Months') }}</div>
            </span>
            <span v-if="key === 'quarter'" class="cursor_pointer" @click="goToCompliance('quarter')">
              <h4 style="color: #D18820;" class="mb-0 impact_type">{{ $t('moderateImpact') }}</h4>
              <div class="expire_time">{{ $t('certificateExpiringWithin3to6Months') }}</div>
            </span>
            <span v-if="key === 'year'" class="cursor_pointer" @click="goToCompliance('year')">
              <h4 style="color: #096072;" class="mb-0 impact_type">{{ $t('lowImpact') }}</h4>
              <div class="expire_time">{{ $t('certificateExpiringWithin6to12Months') }}</div>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xs-12 footer p-0">
      <div class="col-xs-12 p-0">
          <button type="button" class="btn view_all_button" @click="viewAll()">
           <span class="seeMore pr-8">{{ $t('viewAll') }}</span>
            <img src="/static/images/icons/Back.svg" class="pl-10 pb-3" />
          </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: ['widgetTrackplusFlag', 'expiration_details', 'expiryVisible', 'openPopover', 'panel'],
  data() {
    return {};
  },
  methods: {
    goToCompliance(value) {
      this.$router.push({ path: '/layout/registration', query: { compliance: value } });
    },
    viewAll() {
      this.$router.push('/layout/registration');
    },
  },
};
</script>

<style scoped>
.view_all_button,
.view_all_button:hover {
  background-color: #01518A;
  height: 34px;
  width: 123px;
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 600;
  border-radius: 3px;
  line-height: 22px;
  float: right;
  cursor: pointer;
  padding: 6px 20px 6px 16px;
}
#item_number {
  width: 25%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  color: #333333;
}

.mb-0 {
  margin-bottom: 0px;
}

.single_digit {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 30px;
  padding-right: 30px;
}

.double_digit {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 21px;
  padding-right: 21px;
}

.three_digit {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 11px;
  padding-right: 11px;
}

.footer {
  padding-right: 8px;
  padding-left: 20px;
  position: absolute;
  bottom: 8px;
  right: 0px;
}

.seeMore {
  /* font-size: 18px; */
  color: #FFFFFF;
  /* float: right;
  cursor: pointer; */
  /* font-weight: 700;
  line-height: 25px; */
}

.card {
  display: flex;
  border: 1px solid rgb(209, 206, 206);
  margin-bottom: 4px;
  margin-bottom: 5px;
}

.card_details {
  margin-left: 1px;
  display: flex;
  /* padding: 5px 0px 0px 5px; */
  margin-bottom: 22px;
}

.f-12 {
  font-size: 12px;
}

.pt-20 {
  padding-top: 20px;
}

.pb-20 {
  padding-bottom: 20px;
}

.pl-30 {
  padding-left: 30px;
}

/* .mr-15 {
  margin-right: 15px;
} */
.pr-30 {
  padding-right: 30px;
}

.mt--1 {
  margin-top: -1px;
}

.d-flex {
  display: flex;
  /* background-color: rgb(240, 238, 238); */
}

.center {
  align-items: center;
  justify-content: center;
}
.fw-600 {
  font-weight: 600;
}
.fs-xxlarge {
  font-size: xx-large;
}
.jc-end {
  justify-content: flex-end;
}
.mb--10 {
  margin-bottom: -10px;
}
.mt--10 {
  margin-top: -10px;
}
.mt-15 {
  margin-top: 15px;
}
.pl-10 {
  padding-left:10px
}

/* .widget {
  min-height: 376px;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  padding: 6px 16px 25px 16px;
  background: #ffffff;
} */
.dashboard-trackplus-cards .title {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 26px;
  color: #0B3C61;
}

.title {
  padding-left: 1px;
  /* border-bottom: 0.5px solid #B4B4B4; */
  padding-bottom: 33px;
  /* margin-bottom: 16px; */
}

.dashboard-trackplus-cards .track_plus_icon_blue {
  width: 32px;
  height: 32px;
}

.dashboard-trackplus-cards .MT-12 {
  margin-top: 12px;
}

.dashboard-trackplus-cards .pd-10 {
  padding: 10px;
}

.dashboard-trackplus-cards .exp-pd-tp-0 {
  padding-top: 0px !important;
}

.dashboard-trackplus-cards .expiry_pending .tab_expiry {
  line-height: 13px;
}

.dashboard-trackplus-cards .expiry_pending h3 {
  line-height: 33px;
}

.MT-25 {
  margin-top: 25px;
}

.expiry_pending h3 {
  margin-top: 0px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 26px;
  color: #0B3C61;
}

.expiry_pending .tab_expiry {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
  margin-top: 12px;
  margin-bottom: 6px;
}

.expiry_pending .progress_count {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
  float: right;
}

.expiry_pending .green {
  background: #4C9E45;
}

.expiry_pending .orange {
  background: #F2994A;
}

.expiry_pending .blue {
  background: #2F80ED;
}

.expiry_pending .red {
  background: #CF5F28;
}

.expiry_pending .progress {
  height: 11px;
  margin-bottom: 0;
  background: #C4C4C4;
  box-shadow: none;
  border-radius: 8px;
}

.cursor_pointer {
  cursor: pointer !important;
  /* word-break: break-all; */
  white-space: normal;
  padding-left: 16px;
  margin-top: -15px;
}

.compliance_title {
  /* padding-left: 1px; */
  font-weight: 300;
  font-size: 24px;
  line-height: 33px;
  color: #3E3E3E;
}

.summary_line {
  border-bottom: 0.7px solid #BDBDBD;
  padding-bottom: 46px;
  margin: 0;
}

.compliance_details {
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  color: #3E3E3E;
  /* padding-left: 9px; */
  /* padding-top: 12px */
}

.rounded_corner {
  border-radius: 25px;
  border: 2px solid #B4B4B4;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  background: #FFFFFF;
  box-shadow:1.62162px 1.62162px 4.05405px rgba(0, 0, 0, 0.12);
  /* margin-top:5px */
  padding: 3px 10px 4px 10px;
}

.expire_time {
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #3E3E3E;
}

.impact_type {
  font-weight: 600;
  font-size: 16px;
  line-height: 25px;
  margin-top:15px;
}

@media screen and (min-width: 992px) and (max-width: 1366px) {
  .lh-14 {
    line-height: 14px;
  }
}
</style>
